module.exports = __webpack_public_path__ + "static/img/server18.a98493e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server18.png
// module id = x/oz
// module chunks = 1